import { useRef } from 'react'

import { Toast, ToastMessage, ToastProps } from 'primereact/toast'

import { ToastContext } from './toastContext'

interface ToastContextProviderProps {
  position?: ToastProps['position']
  children?: React.ReactNode
}

const ToastContextProvider: React.FC<ToastContextProviderProps> = ({
  position,
  children,
}) => {
  const toastRef = useRef<Toast>(null)

  const showToast = (message: ToastMessage) => {
    if (!toastRef.current) return
    toastRef.current.show(message)
  }

  const replaceToast = (message: ToastMessage) => {
    if (!toastRef.current) return
    toastRef.current.replace(message)
  }

  const removeToast = (message: ToastMessage) => {
    if (!toastRef.current) return
    toastRef.current.remove(message)
  }

  const clearAllToasts = () => {
    if (!toastRef.current) return
    toastRef.current.clear()
  }

  return (
    <ToastContext.Provider
      value={{ showToast, replaceToast, removeToast, clearAllToasts }}
    >
      <>{children}</>
      <Toast
        ref={toastRef}
        position={position}
        pt={{
          root: { className: 'max-h-screen' },
          detail: { className: 'max-h-10rem overflow-y-auto' },
        }}
      />
    </ToastContext.Provider>
  )
}

export default ToastContextProvider
